import { Reducer } from 'react';
import { ActionTypes, SearchContextActions, SearchContextsTypes } from 'pages/Search/View/Main/types';

export const reducer: Reducer<SearchContextsTypes, SearchContextActions> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_ITEM:
      return {
        ...state,
        [payload.item]: payload.value,
      };
    case ActionTypes.SET_MAX_BUST:
      return {
        ...state,
        ...payload,
      };
    case ActionTypes.SET_ACTRESS:
      return {
        ...state,
        ...payload,
      };
  }
};

export default reducer;
